import { PROJECT_VARIANTS } from '../../constants';
import * as genieActions from '../../redux/genie/genieActions';
import * as consumerGenieActions from '../../redux/consumer/genie/consumerGenieActions';
import { uploadFile } from '../../redux/scout/scoutActions';

const consumerValuesArgs = (args) => args.values;

const genieActionsMapping = {
  getData: {
    [PROJECT_VARIANTS.ADMIN]: genieActions.getGenieData,
  },
  predictResponse: {
    [PROJECT_VARIANTS.ADMIN]: genieActions.predictResponse,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieActions.predictConsumerResponse,
    argsTransformer: (args, projectVariant) =>
      projectVariant === PROJECT_VARIANTS.CONSUMER ? consumerValuesArgs(args) : args,
  },
  generateAlternate: {
    [PROJECT_VARIANTS.ADMIN]: genieActions.generateAlternate,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieActions.generateConsumerAlternate,
    argsTransformer: (args, projectVariant) =>
      projectVariant === PROJECT_VARIANTS.CONSUMER ? consumerValuesArgs(args) : args,
  },
  generateMessages: {
    [PROJECT_VARIANTS.ADMIN]: genieActions.generateMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieActions.generateConsumerGenieMessages,
  },
  reply: {
    [PROJECT_VARIANTS.ADMIN]: genieActions.replyGenie,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieActions.replyConsumerGenie,
  },
  resetSession: {
    [PROJECT_VARIANTS.ADMIN]: genieActions.resetSession,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieActions.resetGenieSession,
  },
  getAudiences: {
    [PROJECT_VARIANTS.ADMIN]: genieActions.getGenieAudiences,
    [PROJECT_VARIANTS.CONSUMER]: consumerGenieActions.getConsumerGenieAudiences,
  },
  getBrandOptions: {
    [PROJECT_VARIANTS.ADMIN]: genieActions.getGenieBrandOptions,
    [PROJECT_VARIANTS.CONSUMER]: genieActions.getGenieBrandOptions,
  },
  createCustomMessages: {
    [PROJECT_VARIANTS.ADMIN]: genieActions.createCustomMessages,
  },
  uploadFile: {
    [PROJECT_VARIANTS.ADMIN]: uploadFile,
    [PROJECT_VARIANTS.CONSUMER]: uploadFile,
  },
};

export default genieActionsMapping;
